import { useCallback, useMemo } from 'react';
import './styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIsNewMission } from 'ui/store/actions/gameUIActions';
import { useLocalStorage } from 'ui/hooks/useLocalStorage';
import { UIRootState } from 'ui/store/reducers';
import { GAEvent, GAEventNames } from 'game/analytics/events';

interface StoriesButtonProps {
    type: 'main' | 'secondary';
    onClick: () => void;
}

export const StoriesButton: React.FC<StoriesButtonProps> = ({ onClick, type }) => {
    const dispatch = useDispatch();
    const [tickets] = useLocalStorage<number>('stories_tickets_counter', 0);
    const stories = useSelector((state: UIRootState) => state.gameUI.modals.storiesModal.stories);

    const isVisited = localStorage.getItem('stories-visited') == 'true';

    const handleStoriesClick = useCallback(() => {
        localStorage.setItem('stories-visited', 'true');
        GAEvent(GAEventNames.STORIES_BUTTON_CLICK);
        onClick();
    }, [onClick, dispatch, toggleIsNewMission]);

    const isHaveAvailableStories = useMemo(() => {
        return tickets >= 50 && !!stories.find((story, index) => {
            const progress = parseInt(localStorage.getItem(`stories_story_${index + 1}_progress`) || '0');

            return progress < story.totalImages;
        });
    }, [tickets, stories]);

    return (
        <div className={`mission-button stories-button--${type} custom-circle-btn`}>
            <button 
                id="missionsButton" 
                onClick={handleStoriesClick}
                className="circle-btn btn btn-outline-light border-0 rounded-circle position-relative d-flex align-items-center justify-content-center p-0" 
                style={{ width: '55px', height: '55px' }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <g filter="url(#filter0_d_1109_12839)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.20001 25H8.64001L10.24 8.48L8.96001 6.56V4H12.8V5.92H14.08V4H17.92V5.92H19.2V4H23.04V6.56L21.76 8.48L23.36 25H24.8V28H7.20001V25ZM16 15.6234C15.145 15.6234 14.4516 16.3076 14.4516 17.1519V23.9091H17.5484V17.1519C17.5484 16.3079 16.8552 15.6235 16 15.6234Z" fill="white"/>
                    </g>
                    <defs>
                        <filter id="filter0_d_1109_12839" x="7.20001" y="4" width="17.6" height="25" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="1"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1109_12839"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1109_12839" result="shape"/>
                        </filter>
                    </defs>
                </svg>
            </button>

            {(!isVisited || isHaveAvailableStories) && <div className={`stories-button-indicator stories-button-indicator--${type}`}/>}
        </div>
    );
};